import { Button, ButtonVariant, Input } from '@egw/components'
import { DEFAULT_COUNTRY_CODE } from '@egw/constants'
import { Trans, useTranslation } from '@egw/i18n'
import { Logger } from '@egw/logger'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { formatPhoneNumber } from 'react-phone-number-input'
import { UpdatePhoneField, type UpdatePhoneStep, UpdatePhoneStepEnum } from '../../types/phone/phone-types'
import { getFullPhoneNumber } from '../../utils'

const log = new Logger('Verify Phone Step')

export const VerifyPhoneStep: FC<UpdatePhoneStep> = ({ ctaOnClick, isLoading, resendCode }) => {
  const STEP = UpdatePhoneStepEnum.VERIFY

  const { t } = useTranslation('features-settings')

  const {
    formState: { errors },
    register,
    getValues,
  } = useFormContext()

  const phoneNumber = getValues(UpdatePhoneField.PHONE) as string

  const phone = formatPhoneNumber(
    getFullPhoneNumber({
      phoneNumber,
      countryPhoneCode: DEFAULT_COUNTRY_CODE,
    }),
  )

  return (
    <div className="flex flex-col gap-4">
      <Trans
        className="fs-exclude"
        i18nKey={t(`update_phone.${STEP}.description`)}
        values={{ phone }}
        components={{ b: <strong />, s: <span /> }}
      />

      <Input
        {...register(UpdatePhoneField.OTP_CODE)}
        type="text"
        id={UpdatePhoneField.OTP_CODE}
        testId={UpdatePhoneField.OTP_CODE}
        label={t(`update_phone.${STEP}.input_label`)}
        required
        error={errors[UpdatePhoneField.OTP_CODE]?.message as string}
      />
      <button
        type="button"
        onClick={resendCode}
        className="!justify-start text-left text-action font-semibold text-base"
        id="resendCode"
      >
        {t('settings.personal_info.change.resend_code')}
      </button>
      <Button variant={ButtonVariant.Primary} id="changePhoneContinue" onClick={ctaOnClick} isLoading={isLoading}>
        {t('settings.personal_info.change.continue')}
      </Button>
    </div>
  )
}
